import React, { Component } from 'react';

// Components
import DataService from 'js/modules/dataservice';
import gatracking from 'js/modules/gatracking';

class Tracker extends Component {
  componentDidMount() {
    this.getSummary();
  }

  getSummary = async() => {
    const summaryResponse = await DataService.readSummary();

    const { code, content } = summaryResponse;
    const brand = window._app.brand;
    const step = window._app.page.step;

    if (code === 1) {
      gatracking.track(content, brand, step);
    }
  }

  render() {
    return(
      <div>{ '' }</div>
    );
  }
}

export default Tracker;



// WEBPACK FOOTER //
// ./js/components/global/Tracking.js